// ../utils/navConfig.js
const baseNavItems = [
  { path: '/avatars', label: 'Avatars' },
  { path: '/how-it-works', label: 'How it works' },
  { path: '/examples', label: 'Examples' },
  { path: '/pricing', label: 'Pricing' },
  { path: '/contact', label: 'Contact' },
  // Add more if needed
];

// Add Gen page only in development
const devNavItems = [
  { path: '/gen', label: 'Gen' }
];

// Export navItems based on environment
export const navItems = import.meta.env.DEV 
  ? [...baseNavItems.slice(0, 4), ...devNavItems, ...baseNavItems.slice(4)]
  : baseNavItems;
